import { useEffect, useRef, useState } from "react";
import { useLoading } from "../../helpers/Utils";
import { isEmpty } from "../../helpers/Functions";
import displayToast from "../../theme/partials/DisplayToast";

export const useCrudGetHelper = (getFn = () => { }, configs = {}, withToastError = true) => {
	const [responseData, setResponseData] = useState({});
	const [args, setArgs] = useState([]);
	const { isLoading, addLoading, finishLoading, setIsLoading } = useLoading();

	const eventsRef = useRef({
		onError() { },
		onSuccess() { },
	});

	useEffect(() => {
		if (isEmpty(args)) {
			return;
		}

		addLoading();

		const signal = new AbortController();

		getFn(...args, { ...configs, signal: signal?.signal })
			.then((response) => {
				if (response.data?.init?.[0]?.status === "error") {
					if (withToastError) {
						eventsRef.current?.onError(false, response?.data?.init?.[0]);
						displayToast("error", response?.data?.init?.[0]);
					}
					return;
				}

				setResponseData(response.data);

				eventsRef.current?.onSuccess(response.data);
			})
			.catch((error) => {
				console.error(`Error fetching data (${getFn?.name}):`, error);
				eventsRef.current?.onError(true, error);
			})
			.finally(() => {
				finishLoading();
			});

		return () => {
			signal?.abort?.();
		};
	}, [args]);

	const initCall = (...initArgs) => {
		setArgs(initArgs);
		return eventsRef.current;
	}

	return {
		responseData,
		isLoading,
		initCall,
		setIsLoading,
	};
};
